import {AutocompleteService} from '@frontapp/editor-html';
import React, {FC} from 'react';

import {ConversationModel} from '../../../../models/api/conversationModel';
import {NewPanelId} from '../../../../store/panels/panelStateBase';
import {ServiceSubscription} from '../serviceSubscription';
import {MentionEditorDropdownContentContainer} from './mentionEditorDropdownContentContainer';

/*
 * Props.
 */

export interface MentionEditorDropdownProps {
  panelId: NewPanelId;
  conversation?: ConversationModel;
  autocompleteService: AutocompleteService;
}

/*
 * Component.
 */

export const MentionEditorDropdown: FC<MentionEditorDropdownProps> = ({
  panelId,
  conversation,
  autocompleteService,
}) => (
  <ServiceSubscription source={autocompleteService}>
    {({textBeforeCursor}) => (
      <MentionEditorDropdownContentContainer
        panelId={panelId}
        conversation={conversation}
        textBeforeCursor={textBeforeCursor}
        getAnchorBounds={(partialText) => autocompleteService.getBoundingClientRect(partialText)}
        onTeammateOrContactSelect={(partialText, aliasOrEmail) => {
          autocompleteService.autocomplete(partialText, `@${aliasOrEmail} `);
        }}
      />
    )}
  </ServiceSubscription>
);
